import React, { useState, useEffect } from 'react'
import { Row, Col } from 'react-bootstrap'
import moment from 'moment'
import { Field } from 'redux-form'
import { renderSelectField, renderTextAreaField, renderTextField } from '../../../Forms/fieldRenderers'
import DatePicker from '../../../LaridaeApp/datepicker/container/DatePicker'
import { TRANSPORTE } from '../../../../config/transportes'

const transportes = TRANSPORTE
function CamposPenalizacionTransporte (props) {
  const { fechaD, fechaH } = props
  const [selectedTransporte, setSelectedTransporte] = useState(null)
  const [fechaDesde, setFechaDesde] = useState(moment(fechaD).format('DD-MM-YYYY'))
  const [fechaHasta, setFechaHasta] = useState(moment(fechaH).format('DD-MM-YYYY'))

  useEffect(() => {
    setFechaDesde(moment(fechaD).format('DD-MM-YYYY'))
    setFechaHasta(moment(fechaH).format('DD-MM-YYYY'))
  }, [fechaD, fechaH])

  const renderTransportes = () => {
    const options = transportes.map((transporte) => {
      return (
        <option
          value={transporte}
          key={transporte}
        >
          {transporte.toLocaleUpperCase()}
        </option>
      )
    })
    options.unshift((<option value={null} key={0} />))
    return options
  }

  const actualizarFechas = (fechaD, fechaH) => {
    setFechaDesde(moment(fechaD).format('DD-MM-YYYY'))
    setFechaHasta(moment(fechaH).format('DD-MM-YYYY'))
    props.updateFecha(moment(fechaD).format('DD-MM-YYYY HH:mm:ss'))
  }

  const setTipoTransporte = (t) => {
    setSelectedTransporte(t)
  }

  return (
    <Row style={{ width: '96%', margin: '1% auto' }}>
      <Col md={4} style={{ marginTop: '12px' }}>
        <DatePicker
          selectRange={false}
          locale='es'
          fechaDesde={fechaDesde}
          fechaHasta={fechaHasta}
          onDateChange={actualizarFechas}
          titulo='Fecha vencimiento de penalización'
          value='penalizacionVencimiento'
        />
      </Col>

      <Col md={4}>
        <Field
          onChange={(t) => setTipoTransporte(t)}
          name='penalizacionTransporte'
          label='Tipo de transporte'
          autoFocus={false}
          component={renderSelectField}
          value={selectedTransporte}
        >
          {renderTransportes()}
        </Field>
      </Col>

      <Col md={4}>
        <Field
          name='penalizacionPatente'
          label='Patente *'
          autoFocus={false}
          component={renderTextField}
          placeholder='AA111AA'
          upperCase
        />
      </Col>

      <Col md={12}>
        <Field
          name='penalizacionMotivo'
          component={renderTextAreaField}
          autoFocus={false}
          label='Motivo de penalización *'
          style={{
            width: '100%',
            borderColor: '#d2d2d2',
            borderRadius: '4px',
            minHeight: '80px'
          }}
        />
      </Col>
      <Col md={12} style={{ textAlign: 'rigth', marginTop: '8px' }}>
        <p>(*) Campo requerido obligatorio</p>
      </Col>
    </Row>

  )
}

export default CamposPenalizacionTransporte
